module.exports = __webpack_public_path__ + "static/media/ic-scroll.a13d69c0.png";